import React, { useEffect, useState } from "react";
import {
  ArrowRight,
  Code,
  Globe,
  Zap,
  Users,
  Shield,
  ChevronRight,
  Mail,
  Menu,
  X,
  Phone,
  MapPin,
  Calendar,
  MessageCircle,
  Send,
  WhatsApp,
  ChevronLeft,
  ChevronUp,
} from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";
import Footer from "../components/Footer";
import AppointmentScheduler from "../components/AppointmentScheduler";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import HeroSection from "../components/HeroSection";
import TechnologiesSection from "../components/TechnologiesSection";
import Portafolio from "../components/Portafolio";
import Testimonio from "../components/Testimonio";
import PhoneButton from "../components/ContactButtons";

const HomePage = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("opacity-100");
            entry.target.classList.remove("opacity-0", "translate-y-10");
          }
        });
      },
      { threshold: 0.1 }
    );

    document
      .querySelectorAll(".animate-on-scroll")
      .forEach((el) => observer.observe(el));

    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 500);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      observer.disconnect();
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="min-h-screen bg-black">
      <Navbar />
      <HeroSection />
      {/* Services Section */}
      <section id="servicios" className="py-20 "></section>

      <TechnologiesSection />
      {/* Portfolio Section */}
      <Portafolio />

      <Testimonio />

      <PhoneButton />
      {/* Scroll to Top Button */}
      {/* {showScrollTop && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-6 right-6 z-50 bg-blue-600 text-white p-4 rounded-full shadow-lg hover:bg-blue-700 transition-colors"
        >
          <ChevronUp size={24} />
        </button>
      )} */}
      <section id="agendar">
        <AppointmentScheduler />
      </section>
      <Footer />
    </div>
  );
};

export default HomePage;
